import React from "react";
import img from "../../assets/img/chooseus.webp";
import degree from "../../assets/img/edu.png";
import thumb from "../../assets/img/invis.png";
import message from "../../assets/img/financing-plans.png";

const Chooseus = ({ scrollToConsult }) => {
  return (
    <div
      className="container-fluid mt-3 mb-5 d-flex align-items-center justify-content-end"
      style={{
        height: "90vh",
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="row align-items-center">
        <div className="col-lg-6"></div>
        <div className="col-lg-5 d-flex justify-content-center justify-content-lg-end py-5 px-3 p-lg-0">
          <div className="card rounded-4 p-4">
            <h2 className="card-title">Why Choose Us?</h2>
            <p className="card-text">
              Based in Ilkley with a local, experienced and dedicated team - our
              aim is to put you and your needs first.
            </p>

            <div className="d-flex align-items-center mb-3">
              <img
                src={degree}
                alt="Degree Icon"
                height="60"
                className="rounded-3 me-3"
                loading="lazy"
              />
              <span>Warm and Friendly Environment</span>
            </div>

            <div className="d-flex align-items-center mb-3">
              <img
                src={thumb}
                alt="Thumb Icon"
                height="60"
                loading="lazy"
                className="rounded-3 me-3"
              />
              <span>Diamond Apex Invisalign® Practice</span>
            </div>

            <div className="d-flex align-items-center mb-3">
              <img
                src={message}
                alt="Message Icon"
                height="60"
                loading="lazy"
                className="rounded-3 me-3"
              />
              <span>Flexible Finance Options</span>
            </div>
            <div className="d-flex my-2 my-lg-0 me-1" onClick={scrollToConsult}>
              <a className="w-100 fs-14 btn btn-golden animate__animated animate__fadeIn">
                BOOK A FREE CONSULTATION
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chooseus;
